import { gql } from "apollo-boost"

export const GET_INVOICES = gql`
  query Invoices($id: ID!) {
    Submission:Invoices(id: $id) {
      status
      endDate
      budgeted
      startDate
      evidenced
      approved
      difference
      invoices {
        id        
        paymentAt
        ficosecPayment
        investmentOnePayment
        investmentTwoPayment
        implementerPayment
        amount        
      }      
    }
  }
`